import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";

const STYLES = {
  draft: "bg-[#F9F9F9] text-[#737373] border border-black/10",
  published: "bg-[#1D4D3B]/10 text-[#1D4D3B] border-0",
  live: "bg-[#1D4D3B] text-white border-0",
  ended: "bg-black/5 text-[#0A0A0A]/60 border-0",
  archived: "bg-black/5 text-[#0A0A0A]/40 border-0",
  scheduled: "bg-[#1D4D3B]/10 text-[#1D4D3B] border-0",
  cancelled: "bg-red-50 text-red-700 border border-red-100",
};

export const EventStatusBadge = ({ status, testid }) => {
  const { t } = useTranslation();
  return (
    <Badge
      data-testid={testid || `status-badge-${status}`}
      className={`${STYLES[status] || STYLES.draft} hover:bg-inherit text-[10px] uppercase tracking-wider`}
    >
      {t(`status.${status}`)}
    </Badge>
  );
};
